<template>
    <section>
        <b-loading :active.sync="carregando"></b-loading>

        <titlebar :title-stack="titleStack">
           
        </titlebar>
        <div class="tile is-ancestor">
            <div class="tile is-parent is-vertical is-9">
                <article class="tile is-child box">

                    <div class="columns">
                        <div class="column is-2">
                            <ValidationProvider rules="required" name="apelido" v-slot="{ errors, valid }">
                                <b-field :label="$t('EXAMECADASTRO.APELIDO')"
                                    ref="apelido"
                                            :type="{ 'is-danger': errors[0] || apelidoInvalido, 'is-success': valid }"
                                            :message="getErrosApelido(errors)">
                                    <b-input type="text" v-model="model.apelido" maxlength="10" :has-counter="true" @blur="verificaApelidoExame"></b-input>
                                </b-field>
                            </ValidationProvider>
                        </div>         
                        <div class="column">
                            <ValidationProvider rules="required" name="nome" v-slot="{ errors, valid }">
                                <b-field :label="$t('EXAMECADASTRO.NOME')"
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors">
                                    <b-input type="text" v-model="model.nome" maxlength="150" :has-counter="true"></b-input>
                                </b-field>
                            </ValidationProvider>
                        </div>                                                                                                              
                    </div>

                    <div class="columns">
                        <div class="column">
                                <b-field :label="$t('EXAMECADASTRO.SETOR')">
                                <b-select v-model="model.setor.id" expanded>
                                    <option
                                        v-for="option in setores"
                                        :value="option.value"
                                        :key="option.value">
                                        {{ option.value }} - {{ option.text }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>

                         <div class="column">
                                <b-field :label="$t('EXAMECADASTRO.GEN')">
                                <b-select v-model="model.genero" expanded>
                                    <option value="Todos" > Todos</option>
                                    <option value="M">
                                        {{$t('EXAMECADASTRO.MASC')}}
                                    </option>
                                    <option value="F">
                                        {{$t('EXAMECADASTRO.FEM')}}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>

                        <div class="column">
                                <b-field :label="$t('EXAMECADASTRO.ETQNUMERO')" expanded>
                                    <b-tooltip expanded :label="$t('EXAMECADASTRO.CLIQUESETA')"
                                    type="is-dark"
                                    position="is-top" >
                                    <b-input type="number" icon="forward" v-model="model.agrupamentoDeAmostrasNumero" icon-clickable @icon-click="buscarProximoNumeroEtiqueta" expanded></b-input>                                            
                                </b-tooltip>
                            </b-field>
                        </div>

                        <div class="column">
                                <b-field :label="$t('EXAMECADASTRO.ORDEM')" expanded>
                                    <b-tooltip expanded :label="$t('EXAMECADASTRO.CLIQUESETA')"
                                    type="is-dark"
                                    position="is-top" >
                                    <b-input type="number" icon="forward" v-model="model.ordemNoResultado" icon-clickable @icon-click="buscarProximoNumeroOrdemRestado" expanded></b-input>                                            
                                </b-tooltip>
                            </b-field>
                        </div>                                
                    </div>

                    <div class="columns">
                        <div class="column">
                                <b-field :label="$t('EXAMECADASTRO.QTDEAMOSTRA')">
                                <b-input type="number" v-model="model.quantidadeDeAmostras" max="99999"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                                <b-field :label="$t('EXAMECADASTRO.QTDEETQ')">
                                <b-input type="number" v-model="model.quantidadeDeViasDeEtiqueta" max="99999"></b-input>
                            </b-field>
                        </div>                                  
                        <div class="column">
                                <b-field :label="$t('EXAMECADASTRO.PRAZODIA')">
                                <b-input type="number" v-model="model.prazoDeEntrega" max="99999"></b-input>
                            </b-field>
                        </div>  
                        <div class="column">
                                <b-field :label="$t('EXAMECADASTRO.PRAZOHORA')">
                                <b-input type="number" v-model="model.prazoDeEntregaHoras" max="99999"></b-input>
                            </b-field>
                        </div>                                                           
                        <div class="column">
                                <b-field :label="$t('EXAMECADASTRO.PRAZOMIN')">
                                <b-input type="number" v-model="model.prazoDeEntregaMinutos" max="99999"></b-input>
                            </b-field>
                        </div>                                                                       
                    </div>

                    <div class="columns">
                        <div class="column">
                            <b-field :label="$t('EXAMECADASTRO.MINJEJUM')">
                                <b-input type="number" v-model="model.minimoJejum" max="99999"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field :label="$t('EXAMECADASTRO.VOLDESEJADO')">
                                <b-input v-model="model.volumeDesejado"  maxlength="150" :has-counter="false"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field :label="$t('EXAMECADASTRO.VOLMIN')">
                                <b-input v-model="model.volumeMinimo"  maxlength="150" :has-counter="false"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-field :label="$t('EXAMECADASTRO.SINONIMIA')">
                                <b-input v-model="model.sinonimia"  maxlength="500" :has-counter="false"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field :label="$t('EXAMECADASTRO.ULTIMOSRESUL')">
                                <b-input type="number" v-model="model.quantidadeDeUltimosResultados" max="99999"></b-input>
                            </b-field>
                        </div>
                        <div v-if="model.outrasDespesas" class="column">
                            <b-field :label="$t('EXAMECADASTRO.CODIGOTABELA')">
                                <b-select v-model="model.codigoTabela" expanded>
                                    <option value="00">
                                        00
                                    </option>
                                    <option value="18">
                                        18
                                    </option>
                                    <option value="19">
                                        19
                                    </option>
                                    <option value="20">
                                        20
                                    </option>
                                    <option value="22">
                                        22
                                    </option>
                                    <option value="90">
                                        90
                                    </option>
                                    <option value="98">
                                        98
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                          <div v-if="model.outrasDespesas" class="column">
                            <ValidationProvider rules="required"
                                    name="código de despesas"
                                    v-slot="{ errors, valid }">
                                <b-field :label="$t('EXAMECADASTRO.CODIGODESPESA')" 
                                         :type="{ 'is-danger': errors[0], 'is-success': valid }" 
                                         :message="errors">
                                    <b-select v-model="model.codigoDespesa" expanded>
                                        <option value="01">
                                            01
                                        </option>
                                        <option value="02">
                                            02
                                        </option>
                                        <option value="03">
                                            03
                                        </option>
                                        <option value="05">
                                            05
                                        </option>
                                        <option value="07">
                                            07
                                        </option>
                                        <option value="08">
                                            08
                                        </option>
                                    </b-select>
                                </b-field>
                            </ValidationProvider>
                        </div>
                    </div>
                </article>
                                    
                <article class="tile is-child box">
                    <cadastro-generico :colunas="colunasRecipiente" :label="$t('EXAMECADASTRO.RECIP')" :items.sync="model.recipientes"></cadastro-generico>
                </article>

                <article class="tile is-child box">
                    <div class="panel-heading has-text-centered">
                            Dias de realização
                    </div>
                    <div class="panel-block tile is-12">
                        <b-checkbox-button v-model="diasDaSemana['0']" :native-value="true">{{$t('EXAMECADASTRO.DOMINGO')}}</b-checkbox-button>
                        <b-checkbox-button v-model="diasDaSemana['1']" :native-value="true">{{$t('EXAMECADASTRO.SEGUNDA')}}</b-checkbox-button>
                        <b-checkbox-button v-model="diasDaSemana['2']" :native-value="true">{{$t('EXAMECADASTRO.TERCA')}}</b-checkbox-button>
                        <b-checkbox-button v-model="diasDaSemana['3']" :native-value="true">{{$t('EXAMECADASTRO.QUARTA')}}</b-checkbox-button>
                        <b-checkbox-button v-model="diasDaSemana['4']" :native-value="true">{{$t('EXAMECADASTRO.QUINTA')}}</b-checkbox-button>
                        <b-checkbox-button v-model="diasDaSemana['5']" :native-value="true">{{$t('EXAMECADASTRO.SEXTA')}}</b-checkbox-button>
                        <b-checkbox-button v-model="diasDaSemana['6']" :native-value="true">{{$t('EXAMECADASTRO.SABADO')}}</b-checkbox-button>                                
                    </div>
                </article>

                <article class="tile is-child box">
                    <div class="panel-heading has-text-centered">
                            {{$t('EXAMECADASTRO.OBTAMOSTRA')}}
                    </div>
                    <div class="panel-block column">
                        <div class="column">
                            <b-field :label="$t('EXAMECADASTRO.INFOLAB')">
                                <b-input v-model="model.informacoesAoLaboratorio" type="textarea" expanded/>
                            </b-field>                               
                        </div>
                        <div class="column">
                            <b-field :label="$t('EXAMECADASTRO.INFOPACIENTE')">
                                <b-input v-model="model.informacoesAoPaciente" type="textarea" expanded/>
                            </b-field>                               
                        </div>
                    </div>
                </article>
                <article class="tile is-child box">
                    <div class="panel-heading has-text-centered">
                            {{$t('EXAMECADASTRO.RASBANCADA')}}
                    </div>
                    <div class="panel-block column">
                        <div class="column">
                            <b-field label="">
                                <b-input v-model="model.rascunho" type="textarea" expanded/>
                            </b-field>                               
                        </div>
                    </div>
                </article>      
                <article class="tile is-child box">
                    <div class="panel-heading has-text-centered">
                            {{$t('EXAMECADASTRO.POP')}}
                    </div>
                    <div class="panel-block column">
                        <div class="column">
                            <b-field label="">
                                <b-input v-model="model.pop" type="textarea" expanded/>
                            </b-field>                               
                        </div>
                    </div>
                </article>
                <article class="tile is-child box">
                    <div class="panel-heading has-text-centered">
                            {{$t('EXAMECADASTRO.APLICLINICA')}}
                    </div>
                    <div class="panel-block column">
                        <div class="column">
                            <b-field label="">
                                <b-input v-model="model.aplicacaoClinica" type="textarea" expanded/>
                            </b-field>                               
                        </div>
                    </div>
                </article>   
                <article class="tile is-child box">
                    <div class="panel-heading has-text-centered">
                            {{$t('EXAMECADASTRO.CRITREJEICAO')}}
                    </div>
                    <div class="panel-block column">
                        <div class="column">
                            <b-field label="">
                                <b-input v-model="model.criteriosRejeicao" type="textarea" expanded/>
                            </b-field>                               
                        </div>
                    </div>
                </article>

                <article class="tile is-child box">
                        <cadastro-generico :label="$t('EXAMECADASTRO.CONSEXAME')" 
                            :colunas="colunasConsumiveisExames"  
                            :items.sync="model.consumiveisExame"
                            total="true" colunaTotal="subtotal"
                            ></cadastro-generico>
                </article> 

                <article class="tile is-child box">
                        <cadastro-generico :label="$t('EXAMECADASTRO.PESCLINICA')" 
                            :colunas="colunasPesquisaClinica"  
                            :items.sync="model.pesquisas"
                            ></cadastro-generico>
                </article>
                
                <article class="tile is-child box" v-show="model.id">
                        <cadastro-generico :label="$t('EXAMECADASTRO.EXACOMPLEMENTAR')" 
                            :colunas="colunasExamesComplementares"  
                            :items.sync="model.examesComplementares"                            
                            ></cadastro-generico>
                </article>  

                <article class="tile is-child box" v-if="isInRole('tabelapreço-alterar') || isInRole('tabelapreço-consultar')">
                    <b-collapse class="card has-background-transparent"
                        animation="slide"
                        :open="isOpen"
                        @open="isOpen = !isOpen">
                        <div slot="trigger"
                            slot-scope="props"
                            class="card-header has-background-light has-text-centered"
                            role="button">
                            <p class="card-header-title">
                                {{$t('EXAMECADASTRO.TABPRECO')}}
                            </p>
                            <a class="card-header-icon">
                                <b-icon v-show="props.open" icon="chevron-up"></b-icon>
                                <b-icon v-show="!props.open" icon="chevron-down"></b-icon>
                            </a>
                        </div>
                        <div class="panel-block column">
                            <p v-if="isInRole('tabelapreço-alterar')" class="has-text-centered">
                                <b-button v-if="!bloqueado" type="is-warning" icon-left="lock" @click="bloquearExames()">
                                   {{$t('EXAMECADASTRO.BLOQEXA')}} 
                                </b-button>
                                <b-button v-else type="is-primary" icon-left="lock-open" @click="desbloquearExames()">
                                    {{$t('EXAMECADASTRO.DESBLOQEXA')}}
                                </b-button>
                            </p>
                            <b-table v-if="model.precos.length != 0" :data="model.precos"
                                        :loading="carregando"
                                        striped
                                        hoverable>

                                <template >
                                    <b-table-column  v-slot="props" field="Nome" :label="$t('EXAMECADASTRO.NOME')">
                                        {{ props.row.tabelaPreco.nome }}
                                    </b-table-column>

                                    <b-table-column  v-slot="props" field="Moeda" :label="$t('EXAMECADASTRO.VAL')">
                                        <input v-if="props.row.tabelaPreco.tipo == 'Moeda' || props.row.tabelaPreco.tipo == 'AMB' || props.row.tabelaPreco.tipo == 'Custo'" type="number" step=".00000001" class="input" v-model="props.row.valor" name="Preco" :readonly="!isInRole('tabelapreço-alterar')"  :disabled="!isInRole('tabelapreço-alterar')"/>

                                        <div class="tabela-cbhpm" v-if="props.row.tabelaPreco.tipo == 'CBHPM'">
                                            <input type="text" class="input" v-model="props.row.percentualPorte" name="PercentualPorte" :readonly="!isInRole('tabelapreço-alterar')"  :disabled="!isInRole('tabelapreço-alterar')"/>
                                            <input type="text" class="input" v-model="props.row.custoOperacional" name="CustoOperacional" :readonly="!isInRole('tabelapreço-alterar')"  :disabled="!isInRole('tabelapreço-alterar')"/>
                                            <b-select class="is-fullwidth" v-model="props.row.valorCBHPM">
                                                <option v-for="valorCBHPM in model.valoresCBHPM.id"
                                                        :key="valorCBHPM.id"
                                                        :value="valorCBHPM.id"
                                                        :readonly="!isInRole('tabelapreço-alterar')"  
                                                        :disabled="!isInRole('tabelapreço-alterar')">
                                                    {{ valorCBHPM.valor }}
                                                </option>
                                            </b-select>
                                        </div>

                                    </b-table-column>

                                    <b-table-column v-slot="props" field="Bloqueado" :label="$t('EXAMECADASTRO.BLOQ')" centered>
                                        <b-checkbox class="level-item" v-model="props.row.bloqueado" :readonly="!isInRole('tabelapreço-alterar')"  :disabled="!isInRole('tabelapreço-alterar')">
                                        </b-checkbox>
                                        <b-field>
                                            <b-input v-if="props.row.bloqueado" :placeholder="$t('EXAMECADASTRO.BLOQMOTIVO')" :disabled="!isInRole('tabelapreço-alterar')"
                                                        v-model="props.row.motivoBloqueio"></b-input>
                                        </b-field>
                                    </b-table-column>

                                    <b-table-column v-slot="props" field="RequerAutorizacao" :label="$t('EXAMECADASTRO.AUT')" centered>
                                        <b-checkbox v-model="props.row.requerAutorizacao" :readonly="!isInRole('tabelapreço-alterar')"  :disabled="!isInRole('tabelapreço-alterar')">
                                        </b-checkbox>
                                    </b-table-column>

                                    <b-table-column v-slot="props" field="ValorNegociado" :label="$t('EXAMECADASTRO.NEGOCIADO')" centered>
                                        <b-checkbox v-model="props.row.valorNegociado" :readonly="!isInRole('tabelapreço-alterar')"  :disabled="!isInRole('tabelapreço-alterar')">
                                        </b-checkbox>
                                    </b-table-column>
                                </template>
                            </b-table>
                        </div>
                    </b-collapse>
                </article>                                                                                                                                                   
            </div>


            
            <div class="tile is-parent">
                <article class="tile is-child">    
                        <article class="panel">
                        <div class="panel-block">
                            <b-switch v-model="model.selecionaVersaoDaMascara">
                                {{$t('EXAMECADASTRO.VERSAOMASC')}}
                            </b-switch>
                        </div>
                        <div class="panel-block">
                            <b-switch v-model="model.naoPublicaResultadosNaInternet">
                                 {{$t('EXAMECADASTRO.NAOPUBLICA')}}
                            </b-switch>
                        </div>    
                        <div class="panel-block">
                            <b-switch v-model="model.caraterPlantao">
                                {{$t('EXAMECADASTRO.EMPLANTAO')}}
                            </b-switch>
                        </div>  
                        <div class="panel-block">
                            <b-switch v-model="verificaValorTagFatu">
                               {{$t('EXAMECADASTRO.EXAFATU')}} 
                            </b-switch>
                        </div>
                        <div class="panel-block">
                            <b-switch v-model="verificaValorTagPerfil">
                               {{$t('EXAMECADASTRO.EXAPERFIL')}}
                            </b-switch>
                        </div>                      
                        <div class="panel-block">
                            <b-switch v-model="model.informarMedicamento">
                                {{$t('EXAMECADASTRO.INFOMED')}}
                            </b-switch>
                        </div>                          
                        <div class="panel-block">
                            <b-switch v-model="model.informarHipoteseDiagnostica">
                                {{$t('EXAMECADASTRO.INFOHIPOTESEDIAGNOSTICA')}}
                            </b-switch>
                        </div>   
                        <div class="panel-block">
                            <b-switch v-model="model.informarDUM">
                                {{$t('EXAMECADASTRO.INFODUM')}}
                            </b-switch>
                        </div>  
                        <div class="panel-block">
                            <b-switch v-model="model.informarPeso">
                               {{$t('EXAMECADASTRO.INFOPESO')}} 
                            </b-switch>
                        </div>  
                        <div class="panel-block">
                            <b-switch v-model="model.informarAltura">
                                {{$t('EXAMECADASTRO.INFOALTURA')}}
                            </b-switch>
                        </div>
                        <div class="panel-block">
                            <b-switch v-model="model.resultadoParcial">
                                {{$t('EXAMECADASTRO.LIBERAPARCIAL')}}
                            </b-switch>
                        </div> 
                        <div class="panel-block">
                            <b-switch v-model="model.bloqueioExameRepetido" type="is-danger">
                                {{$t('EXAMECADASTRO.BLOQREPETIDO')}}
                            </b-switch>
                        </div>          
                        <div class="panel-block">
                            <b-switch v-model="model.outrasDespesas">
                                {{$t('EXAMECADASTRO.OUTRASDESPESAS')}}
                            </b-switch>
                        </div> 
                        <div class="panel-block">
                            <b-switch v-model="model.laudoRestrito">
                                {{$t('EXAMECADASTRO.LAUDORESTRITO')}}
                            </b-switch>
                        </div>
                        <div class="panel-block">
                            <b-switch v-model="model.exameAliquota">
                                {{$t('EXAMECADASTRO.EXAMEALIQUOTA')}}
                            </b-switch>
                        </div>                         
                        <div class="panel-block">
                            <b-switch v-model="model.desativado" type="is-danger">
                                {{$t('EXAMECADASTRO.DESATIVADO')}}
                            </b-switch>
                        </div>
                        </article>   
                    <article class="panel" v-if="model.id">
                        <div class="panel-block">
                            <a :href="'/Manutencao/Mascara/' + model.id" class="button is-info is-fullwidth">{{$t('EXAMECADASTRO.EDITARMASCARA')}}</a>                                    
                        </div>
                        <div class="panel-block">
                            <router-link :to="{ name: 'liberacaoautomatica', params: {id: model.apelido} }" class="button is-primary is-fullwidth">
                                {{$t('EXAMECADASTRO.LIBAUTO')}}
                            </router-link>
                        </div>                               
                    </article>         
                    <article class="panel">
                        <historico-alteracoes :tabela="'Exame'" :chave="model.id"></historico-alteracoes>
                    </article>
                    <article class="panel">
                        <div class="panel-heading has-text-centered">
                            {{$t('EXAMECADASTRO.CODINTEG')}}
                        </div>
                        <div class="panel-block">
                            <table class="table is-bordered is-striped is-fullwidth">
                                <thead>
                                    <tr>
                                        <th>{{$t('EXAMECADASTRO.TIPO')}}</th>
                                        <th>{{$t('EXAMECADASTRO.CODIGO')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in model.codigos" v-bind:key="index">
                                        <td>
                                            {{item.exameCodigoTipo.nome}}
                                        </td>
                                        <td>
                                            <input class="input" type="text" v-model="item.codigo">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>                               
                    </article>
                </article>
            </div>
        </div>
        <nav class="level">
            <div class="level-item">
                <p class="buttons">
                    <b-button type="is-success"
                                v-show="isInRole('exame-alterar')"
                                :loading="salvandoDados"
                                @click="onSubmit()"
                                icon-left="check-circle">
                        {{$t('EXAMECADASTRO.SALVAR')}}
                    </b-button>
                    <b-button type="is-danger"
                                native-type="button"
                                icon-left="close-circle"
                                @click="$router.back();">
                         {{$t('EXAMECADASTRO.CANCELAR')}}
                    </b-button>
                </p>
            </div>
        </nav>
    </section>
</template>
<style lang="scss" scoped>
    .is-expanded{
        width: 100%;
        span {
            width: 100%;
        }
    }
</style>

<script>
    import { mapGetters, mapState } from 'vuex'
    import titlebar from '@/components/titlebar.vue'
    import cadastroGenerico from '@/components/cadastroGenerico.vue'
    
    import historicoAlteracoes from '@/components/historicoAlteracoes.vue'

    export default {
        data() {
            return {
                model: {
                    id: null,
                    agrupamentoDeAmostrasNumero: null,
                    apelido: null,
                    aplicacaoClinica: null,
                    caraterPlantao: false,
                    codigoIntegracao: null,
                    codigos: [], //{exameCodigoTipo: {id: 3, nome: "DCNET ESP"}, codigo: "1014"}
                    consumiveisExame: [], //{id: 2, consumivel: {id: 44, nome: "Teste Treinamento"}, quantidade: 1, custoUnitario: 2}
                    criteriosRejeicao: null,
                    diasRealizacao: null,
                    examesComplementares: [],
                    informacoesAoLaboratorio: null,
                    informacoesAoPaciente: null,
                    informarAltura: false,
                    informarDUM: false,
                    informarMedicamento: false,
                    informarHipoteseDiagnostica: false,
                    informarPeso: false,
                    mascaras: [], //{nome: "1", versao: 1, exame: null, mascaraHtml: null, mascaraHtmlUltimaModificacao: null,…}
                    minimoJejum: null,
                    naoExibirLaudoWebPendente: false,
                    naoPublicaResultadosNaInternet: false,
                    nome: null,
                    ordemNoResultado: null,
                    pesquisas: [], //{id: 7, nome: "Documentos do Paciente"}
                    pop: null,
                    prazoDeEntrega: null,
                    prazoDeEntregaHoras: null,
                    prazoDeEntregaMinutos: null,
                    precos: [], //{tabelaPreco: {id: 4, nome: "AMB", tipo: "AMB", valoresCBHPM: null}
                    quantidadeDeAmostras: null,
                    quantidadeDeViasDeEtiqueta: null,
                    rascunho: null,
                    recipientes: [], //{id: 5001, material: {id: 2, nome: "Soro", codigosIntegrador: null}
                    resultadoParcial: false,
                    bloqueioExameRepetido: false,
                    laudoRestrito: false,
                    selecionaVersaoDaMascara: false,
                    setor: {id: 0, nome: null},
                    sinonimia: null,
                    volumeDesejado: null,
                    volumeMinimo: null,
                    codigosIntegrador: [],
                    genero: null,
                    quantidadeDeUltimosResultados: null,
                    codigoDespesa: null,
                    codigoTabela: "00",
                    examePerfil: false,
                },
                isOpen: false,
                setores: [],
                salvandoDados: false,
                colunasRecipiente: [
                    {valor: 'id', label: 'Código', readonly: true, valorPadrao: 0 },
                    {valor: 'material', label: 'Material', tipo: 'select', opcoes: [] },
                    {valor: 'conservante', label: 'Conservante', tipo: 'select', opcoes: [] },
                    {valor: 'estabilidadeAmbiente', label: 'Estabilidade Ambiente (h)', tipo: 'numero', valorPadrao: 0},
                    {valor: 'estabilidadeRefrigerado', label: 'Estabilidade Refrigerado (h)', tipo: 'numero', valorPadrao: 0},
                    {valor: 'estabilidadeCongelado', label: 'Estabilidade Congelado (h)', tipo: 'numero', valorPadrao: 0}
                ],
                colunasConsumiveisExames: [
                    {valor: 'consumivel', label: 'Consumivel', colunas: [
                        {valor: 'id', label: 'Id do Consumível', tipo:"numero", carregarCampo: "nome"}
                        ,{valor: 'nome', label: 'Nome', tipo: 'autocomplete'}]
                        , dinamica: true
                        , tabela: 'Consumivel'
                    },                    
                    {valor:'status', label: 'Status', tipo:'select', opcoes: [] },
                    {valor:'compartilhado', label: 'Compartilhado', tipo:'select', opcoes: [] },
                    {valor:'quantidade', label: 'Quantidade', tipo:"numero", passos:"0.1"},
                    {valor:'custoUnitario', label: 'Preço Unitário', tipo:"numero", passos:"0.1"},
                    {valor:'subtotal', label: 'Subtotal', tipo:"subtotal", fn: (row) => {
                        return row.custoUnitario * row.quantidade;
                    }}
                ],
                colunasPesquisaClinica: [
                    {valor: 'id', label: 'Id da Pesquisa', tipo:"numero", carregarCampo: "nome", carregarCampoId: 'id', tabela: 'Pesquisa'},
                    {valor: 'nome', label: 'Nome', tipo:"autocomplete", dinamica: true, tabela: "Pesquisa"}
                ],
                colunasExamesComplementares: [
                    {valor: 'id', label: 'Id do Exame', tipo:"numero", carregarCampo: "nome", carregarCampoId: 'id', tabela: 'Exame', filtroFixo: {exameId: this.model?.id}, campoIdComponente: 'id'},
                    {valor: 'nome', label: 'Nome', tipo:"autocomplete", dinamica: true, tabela: "Exame"}
                ],
                carregando: false,
                diasDaSemana: {
                    '0': false,
                    '1': false,
                    '2': false,
                    '3': false,
                    '4': false,
                    '5': false,
                    '6': false,
                },
                apelidoInvalido: false,
                bloqueado: false,
            };
        },
        components: {
            titlebar,
            cadastroGenerico,
            historicoAlteracoes
        },
        created() {
            try {
                this.carregando = true;
                this.$http.get('/api/manutencao/setores?all=true')
                                .then(res => {
                                    this.setores = res.data;
                            }).catch(e => {
                                this.carregando = false;
                                throw e;

                            });
                            const id = this.$route.params.id ? this.$route.params.id : '';
                            const colunaExameComplementarFiltroFixo = this.colunasExamesComplementares?.find(c => c.carregarCampo);
                            if (colunaExameComplementarFiltroFixo){
                                colunaExameComplementarFiltroFixo.filtroFixo = {
                                    exameId: id
                                }
                            }
                this.$http.get('/api/manutencao/exame?id=' + id)
                    .then(res => {
                        const dados = {...res.data};
                        dados.recipientes = dados.recipientes?.map(r => {
                            return {
                                ...r,
                                conservanteId: r.conservante?.id                               
                            }
                        });
                        this.model = dados;
                        const material = this.colunasRecipiente.find(r => r.valor === 'material');
                        if (material){
                            material.opcoes = this.model.materiais;
                        }
                        const conservante = this.colunasRecipiente.find(r => r.valor === 'conservante');
                        if (conservante){
                            conservante.opcoes = this.model.conservantes
                        }
                        //Força a recarga das colunas no componente
                        this.colunasRecipiente = [...this.colunasRecipiente];
                        
                        this.model.consumiveisExame = this.model.consumiveisExame?.map(c => {
                            return {
                                ...c,
                                // eslint-disable-next-line
                                consumivel__id: c.consumivel?.id,
                                // eslint-disable-next-line
                                consumivel__nome: c.consumivel?.nome
                            }
                        });

                        this.$http.get('/api/manutencao/ConsumiveisExamesCompartilhado')
                            .then(res => {
                                const consumivelExameCompartilhado = this.colunasConsumiveisExames.find(r => r.valor === 'compartilhado');
                                if (consumivelExameCompartilhado){
                                    consumivelExameCompartilhado.opcoes = res.data.map(item => {
                                        return {
                                            id: item.id,
                                            nome: item.nome
                                        }
                                    });
                                }
                                //Força a recarga das colunas no componente
                                this.colunasConsumiveisExames = [...this.colunasConsumiveisExames];
                            })

                        this.$http.get('/api/manutencao/consumiveisExamesStatus')
                            .then(res => {
                                const status = this.colunasConsumiveisExames.find(r => r.valor === 'status');
                                if (status){
                                    status.opcoes = res.data.map(item => {
                                        return {
                                            id: item.id,
                                            nome: item.nome
                                        }
                                    });
                                }
                                //Força a recarga das colunas no componente
                                this.colunasConsumiveisExames = [...this.colunasConsumiveisExames];
                            })



                        if (this.model.diasRealizacao){
                            this.model.diasRealizacao?.forEach(d => {
                                this.diasDaSemana[d?.toString()] = true;
                            });
                        }else{
                            Object.keys(this.diasDaSemana).forEach(k => {
                                this.diasDaSemana[k] = true;
                            })
                        }

                        delete this.model.mascaras;

                        this.model.precos = this.model.precos?.filter(x => !x.tabelaPreco.desativado).map(p => {

                            p.valor = parseFloat(p.valor).toFixed(2);

                            if(isNaN(p.valor)){
                                p.valor = 0;
                            }

                            if (!this.model.id){
                                delete p.exame;
                                return p;
                            }else{
                                return {
                                    ...p,
                                    exame: {
                                        id: this.model.id ,
                                        nome: this.model.nome ,
                                        apelido: this.model.apelido,
                                    }
                                }
                            }
                        })

                        this.$nextTick(() => {
                            this.$refs.apelido.$el.getElementsByClassName('input')[0].focus()
                        });
                }).catch(e => {
                    this.carregando = false;
                    throw e;

                });                
            }finally{
                this.carregando = false;
            }
        },
        computed: {
            titleStack() {
                return [
                    this.$t('EXAMECADASTRO.MANUTENCAO'),
                    this.$t('EXAMECADASTRO.EXAME'),
                    (this.model.id && this.model.id != 0) ? this.model.id : this.$t('SISTEMA.NOVO')
                ]
            },          
            ...mapState([
                'unidadeId',
                'config',
                'status',
                'integradores'
            ]),
            ...mapGetters([
                'isInRole'
            ]),
            verificaValorTagPerfil: {
                get(){
                    return this.model.examePerfil
                },
                set(val){
                    this.model.examePerfil = val
                }
            },
            verificaValorTagFatu:{
                get(){
                    return this.model.naoExibirLaudoWebPendente
                },
                set(val){
                    this.model.naoExibirLaudoWebPendente = val
                }
            }
        },
        watch: {
          
        },
        methods: {
            onSubmit() {
                if (this.model.apelido == null || this.model.apelido == "") {
                    return this.$buefy.toast.open({
                        duration: 1000,
                        message: this.$t('EXAMECADASTRO.ALERTACAMPOAPELIDO'),
                        type: 'is-danger',
                        queue: false
                    })
                }

                if (this.model.nome == null || this.model.nome == "") {
                    return this.$buefy.toast.open({
                        duration: 1000,
                        message: this.$t('EXAMECADASTRO.ALERTACAMPONOME'),
                        type: 'is-danger',
                        queue: false
                    })
                }

                if (this.model.codigoDespesa == null && this.model.outrasDespesas) {
                    return this.$buefy.toast.open({
                        duration: 1000,
                        message: "O campo código despesa deve ser preenchido",
                        type: 'is-danger',
                        queue: false
                    })
                }

                if((this.model.codigoTabela == null || this.model.codigoTabela == "") && this.model.outrasDespesas) {
                    this.model.codigoTabela = "00";
                }
                
                const newItem = Object.assign({}, this.model);
                if (!this.$route.params.id){
                    delete newItem.id;
                }

                const adicionarExameAosItens = (nomeArray, variavel) => {
                    if (variavel[nomeArray]){
                        variavel[nomeArray] = variavel[nomeArray]?.map(c => {
                            return {
                                ...c,
                                exame: {id: this.model.id, nome: this.model.nome, apelido: this.model.apelido}
                            }
                        })
                    }
                }

                adicionarExameAosItens('consumiveisExame', newItem);
                adicionarExameAosItens('examesComplementares', newItem);
                adicionarExameAosItens('pesquisas', newItem);
                adicionarExameAosItens('recipientes', newItem);                

                if (newItem.codigosIntegrador){
                    newItem.codigosIntegrador = newItem.codigosIntegrador.map(i => {
                        return {
                            codigo: i.codigo,
                            integradorExameId: {
                                codigo: i.codigo,
                                integradorId: i.integradorId
                            }
                        }
                    }).filter(i => i.integradorExame?.integradorId?.toString()?.trim());
                }

                newItem.examesComplementares = newItem.examesComplementares?.map(e => {
                    return e['__resultado'];
                })

                let diasDaSemana = '';
                const addToDiasDaSemana = (valor) => {
                    if (!diasDaSemana.length) diasDaSemana = '?';
                    else diasDaSemana += '&';

                    diasDaSemana += valor;
                }
                
                if (this.diasDaSemana['0']) addToDiasDaSemana('domingo=true');
                if (this.diasDaSemana['1']) addToDiasDaSemana('segunda=true');
                if (this.diasDaSemana['2']) addToDiasDaSemana('terca=true');
                if (this.diasDaSemana['3']) addToDiasDaSemana('quarta=true');
                if (this.diasDaSemana['4']) addToDiasDaSemana('quinta=true');
                if (this.diasDaSemana['5']) addToDiasDaSemana('sexta=true');
                if (this.diasDaSemana['6']) addToDiasDaSemana('sabado=true');

                delete newItem.diasRealizacao;

                //desconsiderando valores com id null para consumiveis, pesquisas e exames complementares
                newItem.consumiveisExame = newItem.consumiveisExame?.filter(c => c.consumivel?.id != null); 
                newItem.pesquisas = newItem.pesquisas?.filter(c => c.id != null); 
                newItem.examesComplementares = newItem.examesComplementares?.filter(c => c.id != null);
                
                newItem.genero = (newItem.genero=="Todos") ? null : newItem.genero;

                //Formatando os valores de recipientes e consumiveis para que sejam 0 caso estejam null
                newItem.recipientes = newItem.recipientes?.map(r => {
                    if (!r.estabilidadeAmbiente) r.estabilidadeAmbiente = 0;
                    if (!r.estabilidadeRefrigerado) r.estabilidadeRefrigerado = 0;
                    if (!r.estabilidadeCongelado) r.estabilidadeCongelado = 0;
                    
                    return r;
                });

                newItem.consumiveisExame = newItem.consumiveisExame?.map(r => {

                    if (!r.custoUnitario) r.custoUnitario = 0;
                    if (!r.quantidade) r.quantidade = 0;
                    
                    r.status = r.status.id;
                    r.compartilhado = r.compartilhado.id;

                    return r;
                });

                if(!this.apelidoInvalido){

                    this.salvandoDados = true
                    this.$http.post(`/api/manutencao/exame${diasDaSemana}`, newItem)
                        .then((res) => {
                            if (res.data && !this.model.id){
                                this.abrir(`/Manutencao/Mascara/${res.data}`);
                            }else{
                                this.$router.back()
                            }
                        })
                        .catch(err => {
                            Object.keys(err.body.errors).forEach(x => {
                                this.$store.commit('ADD_ERRO', x + ": " + err.body.errors[x])
                            })
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: 'Erro ao salvar exame',
                                type: 'is-danger',
                                queue: false
                            })
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        })
                        .finally(() => {
                            this.salvandoDados = false
                        })   
                }
            },
            addCodigo() {
                this.model.codigosIntegrador.push({
                    integradorId: null,
                    codigo: null
                });
            },
            buscarProximoNumeroEtiqueta(){
                this.$http.get('/api/manutencao/proximoEtiquetaNumeroExame?setorId=' + this.model.setor?.id + `&_=${new Date().getTime()}`)
                .then(res => {
                    if (res.data != null){
                        this.model.agrupamentoDeAmostrasNumero = res.data;
                    }

                });

            },
            buscarProximoNumeroOrdemRestado(){
                 this.$http.get('/api/manutencao/proximoOrdemNoResultado?setorId=' + this.model.setor?.id + `&_=${new Date().getTime()}`)
                .then(res => {
                    if (res.data != null){
                        this.model.ordemNoResultado = res.data;
                    }

                });

            },
            getErrosApelido(erros){
                if (this.apelidoInvalido){
                    erros = [...erros, this.$t('EXAMECADASTRO.APELIDOEXISTE')]
                }
                return erros;

            },
            verificaApelidoExame(apelido){
                this.apelidoInvalido = false;

                 this.$http.get(`/api/manutencao/VerificaApelidoExame?exameId=${this.model.id}&exameApelido=${encodeURIComponent(apelido.target.value)}`)
                .then(res => {
                    if (!res.data?.valido){
                        this.apelidoInvalido = true;
                        this.$forceUpdate();
                    }
                });                
            },
            abrir(url){
                window.location = url;
            },
            bloquearExames(){
                this.model.precos.forEach(examePreco => examePreco.bloqueado = true);
                this.bloqueado = true;
            },
            desbloquearExames(){
                this.model.precos.forEach(examePreco => examePreco.bloqueado = false);
                this.bloqueado = false;
            }
        }
    }
</script>